import initializeWindowTitle from 'owa-shared-bootstrap/lib/initializeWindowTitle';
import { getAppNameForModule } from './getAppNameForModule';
import { getCurrentModule } from 'mini-app-module-store/lib/selectors/getCurrentModule';
import { getWindowTitle } from 'mini-window-title/lib/getWindowTitle';
import { type OwaWorkload, setOwaWorkload } from 'owa-workloads';
import { setApp } from 'owa-config/lib/bootstrapOptions';
import { updateModule } from 'mini-app-module-store/lib/actions/updateModule';
import { updateServiceConfig } from 'owa-service/lib/config';
import type { BootstrapOptions } from 'mini-bootstrap';

export function updateModuleForVdirChange(options: BootstrapOptions) {
    const newModule = options.appModuleProps.module;

    if (getCurrentModule() !== newModule) {
        const newApp = getAppNameForModule(newModule);
        setApp(newApp);
        updateServiceConfig({ appName: newApp });
        initializeWindowTitle(() => getWindowTitle(options.getModuleName()));
        setOwaWorkload(options.workload || 0);
        updateModule(newModule);
        options.appModuleProps.activeModuleAction?.();
    }
}
